export default __webpack_public_path__ + "static/media/compare.03663a62.svg";